/* @generated */
/* empty css                                        */var visuallyHidden = "dig-xd70la0_3-8-0";
export {
  visuallyHidden
};
